import React, { useEffect } from "react";
import Button from "components/lbc-toolkit/atomics/Button/DefaultButton";
import translations from "translations";
import { Theme, createStyles, makeStyles } from "@material-ui/core";
import downloadBase64File from "lib/formToolHelpers/downloadBase64File";
import { useGetStudentIdCardLazyQuery } from "graphqlBase/StudentIdCard/__generated__/getStudentIdCard";

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    addButton: {
      fontSize: 14,
      color: theme.colors.tWhite,
      backgroundColor: theme.colors.sunYellow,
      height: 40,
      borderRadius: "unset",
      "&:hover": { color: theme.colors.tWhite, backgroundColor: theme.colors.sunYellow },
    },
  })
);

interface Props {
  id: number;
}

const StudentIdCard: React.FC<Props> = ({ id }) => {
  const classes = useStyles();
  const [query, { data }] = useGetStudentIdCardLazyQuery({
    fetchPolicy: "network-only",
  });

  const handleClick = () => {
    query({ variables: { studentId: id } });
  };

  useEffect(() => {
    if (!data) {
      return;
    }
    const fileName = data?.studentIdCard?.fileName;
    const base64String = data?.studentIdCard?.fileContentBase64;
    if (!base64String) {
      return;
    }
    downloadBase64File("application/pdf", base64String, `${fileName}`);
  }, [data, id]);

  return (
    <Button
      onClick={handleClick}
      label={`${"Studierendenausweis"} ${translations.globals.button.download}`}
      buttonType="primary"
      classes={{ colorPrimary: classes.addButton }}
    />
  );
};

export default StudentIdCard;
